export default {
  methods: {
    openModal(model) {
      this[model] = true;
    },

    closeModal(model) {
      this[model] = false;
    },
  },
};
